<template>
  <section class="pathways-section">
    <div class="path-container">
      <div class="path-header reveal" style="--reveal-delay: 0ms">
        <span class="path-badge">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" />
            <path d="M9 5a2 2 0 012-2h2a2 2 0 012 2v0a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            <path d="M9 14l2 2 4-4" />
          </svg>
          {{ $t('howItWorks.path_badge') }}
        </span>
        <h2 class="path-title">{{ $t('howItWorks.path_title') }}</h2>
        <p class="path-subtitle">{{ $t('howItWorks.path_subtitle') }}</p>
      </div>

      <div class="fork-divider reveal" style="--reveal-delay: 60ms">
        <svg class="fork-svg" viewBox="0 0 140 48" fill="none">
          <path d="M70 48V16M70 16c0-8-8-14-18-14M70 16c0-8 8-14 18-14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          <circle cx="70" cy="16" r="4" fill="currentColor"/>
          <circle cx="52" cy="2" r="2.5" fill="currentColor" opacity="0.5"/>
          <circle cx="88" cy="2" r="2.5" fill="currentColor" opacity="0.5"/>
        </svg>
      </div>

      <div class="paths-grid">
        <!-- DIRECT PATH -->
        <div class="path-card path-direct reveal" style="--reveal-delay: 120ms">
          <div class="path-card-header">
            <div class="path-card-icon">
              <svg viewBox="0 0 40 40" fill="none">
                <rect x="2" y="2" width="36" height="36" rx="10" stroke="currentColor" stroke-width="1.5" fill="currentColor" fill-opacity="0.08"/>
                <path d="M20 12c-2.2 0-4 1.8-4 4 0 2 1.6 3.6 3.6 3.8l-1.4 4.2h-2.2a2 2 0 00-2 2v2h12v-2a2 2 0 00-2-2h-2.2l-1.4-4.2c2-.2 3.6-1.8 3.6-3.8 0-2.2-1.8-4-4-4z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
                <path d="M16 34h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </div>
            <div>
              <h3 class="path-card-title">{{ $t('howItWorks.direct_title') }}</h3>
              <p class="path-card-sub">{{ $t('howItWorks.direct_sub') }}</p>
            </div>
          </div>

          <div class="path-steps">
            <div class="ps">
              <span class="ps-num ps-num-a">{{ $t('howItWorks.num_a_1') }}</span>
              <div class="ps-body">
                <h4 class="ps-title">{{ $t('howItWorks.direct_step1_title') }}</h4>
                <p class="ps-desc">{{ $t('howItWorks.direct_step1_desc') }}</p>
              </div>
            </div>
            <div class="ps-conn">
              <svg width="16" height="24" viewBox="0 0 16 24" fill="none">
                <path d="M8 0v18M2 12l6 6 6-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="ps">
              <span class="ps-num ps-num-a">{{ $t('howItWorks.num_a_2') }}</span>
              <div class="ps-body">
                <h4 class="ps-title">{{ $t('howItWorks.direct_step2_title') }}</h4>
                <p class="ps-desc">{{ $t('howItWorks.direct_step2_desc') }}</p>
              </div>
            </div>
            <div class="ps-conn">
              <svg width="16" height="24" viewBox="0 0 16 24" fill="none">
                <path d="M8 0v18M2 12l6 6 6-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="ps">
              <span class="ps-num ps-num-a">{{ $t('howItWorks.num_a_3') }}</span>
              <div class="ps-body">
                <h4 class="ps-title">{{ $t('howItWorks.direct_step3_title') }}</h4>
                <p class="ps-desc">{{ $t('howItWorks.direct_step3_desc') }}</p>
              </div>
            </div>
          </div>

          <div class="path-services">
            <span class="service-chip">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
              {{ $t('howItWorks.service_contract') }}
            </span>
            <span class="service-chip">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="10" r="3"/><path d="M12 21.7C17.3 17 20 13 20 10a8 8 0 10-16 0c0 3 2.7 7 8 11.7z"/></svg>
              {{ $t('howItWorks.service_transport') }}
            </span>
            <span class="service-chip">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
              {{ $t('howItWorks.service_payment') }}
            </span>
          </div>

          <button class="path-cta path-cta-direct" @click="$emit('contact')">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/></svg>
            {{ $t('howItWorks.direct_cta') }}
          </button>
        </div>

        <!-- DIVIDER / OR -->
        <div class="path-or reveal" style="--reveal-delay: 180ms">
          <div class="or-line"></div>
          <span class="or-badge">{{ $t('howItWorks.or_text') }}</span>
          <div class="or-line"></div>
        </div>

        <!-- SARVBAN PATH -->
        <div class="path-card path-sarvban reveal" style="--reveal-delay: 240ms">
          <div class="path-card-header">
            <div class="path-card-icon">
              <svg viewBox="0 0 40 40" fill="none">
                <rect x="2" y="2" width="36" height="36" rx="10" stroke="currentColor" stroke-width="1.5" fill="currentColor" fill-opacity="0.08"/>
                <path d="M20 6c-4 0-8 3-8 8 0 5 4 10 8 14 4-4 8-9 8-14 0-5-4-8-8-8z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" fill="currentColor" fill-opacity="0.15"/>
                <circle cx="20" cy="14" r="3" stroke="currentColor" stroke-width="1.5"/>
                <path d="M20 20v4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </div>
            <div>
              <h3 class="path-card-title">{{ $t('howItWorks.sarvban_title') }}</h3>
              <p class="path-card-sub">{{ $t('howItWorks.sarvban_sub') }}</p>
            </div>
          </div>

          <div class="path-steps">
            <div class="ps">
              <span class="ps-num ps-num-b">{{ $t('howItWorks.num_b_1') }}</span>
              <div class="ps-body">
                <NuxtLink
                :to="'/add-ord'"
                target="_blank"
                >
                <h4 class="ps-title">{{ $t('howItWorks.sarvban_step1_title') }}</h4>
              </NuxtLink>
                <p class="ps-desc">{{ $t('howItWorks.sarvban_step1_desc') }}</p>
              </div>
            </div>
            <div class="ps-conn">
              <svg width="16" height="24" viewBox="0 0 16 24" fill="none">
                <path d="M8 0v18M2 12l6 6 6-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="ps">
              <span class="ps-num ps-num-b">{{ $t('howItWorks.num_b_2') }}</span>
              <div class="ps-body">
                <h4 class="ps-title">{{ $t('howItWorks.sarvban_step2_title') }}</h4>
                <p class="ps-desc">{{ $t('howItWorks.sarvban_step2_desc') }}</p>
              </div>
            </div>
            <div class="ps-conn">
              <svg width="16" height="24" viewBox="0 0 16 24" fill="none">
                <path d="M8 0v18M2 12l6 6 6-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="ps">
              <span class="ps-num ps-num-b">{{ $t('howItWorks.num_b_3') }}</span>
              <div class="ps-body">
                <h4 class="ps-title">{{ $t('howItWorks.sarvban_step3_title') }}</h4>
                <p class="ps-desc">{{ $t('howItWorks.sarvban_step3_desc') }}</p>
              </div>
            </div>
          </div>

          <div class="path-benefits">
            <div class="benefit">
              <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
                <path d="M5 10l3 3 7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>{{ $t('howItWorks.benefit_low_cost') }}</span>
            </div>
            <div class="benefit">
              <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
                <path d="M5 10l3 3 7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>{{ $t('howItWorks.benefit_expert') }}</span>
            </div>
            <div class="benefit">
              <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
                <path d="M5 10l3 3 7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>{{ $t('howItWorks.benefit_delivery') }}</span>
            </div>
          </div>

          <button class="path-cta path-cta-sarvban" @click="$emit('order')">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
            {{ $t('howItWorks.sarvban_cta') }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { defineNuxtLink } from 'nuxt/app'

defineEmits(['contact', 'order'])

onMounted(() => {
  if (process.client) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible')
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    )
    document.querySelectorAll('.reveal').forEach((el) => observer.observe(el))
  }
})
</script>

<style lang="scss" scoped>
@use "sass:color";

$copper:     $secondary;
$copper-soft: $secondary;
$copper-dim:  rgba(200, 134, 26, 0.08);

.pathways-section {
  position: relative;
  overflow: hidden;
  padding: 56px 16px 64px;
  font-family: 'IRANYekan', 'Vazirmatn', sans-serif;
  direction: rtl;
  color: $ink;
  margin-top: 1rem;
}

.path-atmosphere {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}

.path-grain {
  position: absolute;
  inset: -50%;
  opacity: 0.2;
  background-image:
    radial-gradient(circle at 30% 15%, rgba(232, 168, 56, 0.04) 0%, transparent 45%),
    radial-gradient(circle at 70% 85%, rgba(3, 160, 84, 0.03) 0%, transparent 45%),
    url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.35'/%3E%3C/svg%3E");
  mix-blend-mode: multiply;
}

.path-blob {
  position: absolute;
  opacity: 0.45;
  filter: blur(12px);

  &.blob-1 {
    width: 320px;
    height: 320px;
    color: rgba(232, 168, 56, 0.1);
    top: -100px;
    left: -100px;
    animation: pb-1 26s ease-in-out infinite;
  }

  &.blob-2 {
    width: 280px;
    height: 280px;
    color: rgba(3, 160, 84, 0.07);
    bottom: -80px;
    right: -80px;
    animation: pb-2 22s ease-in-out infinite;
  }
}

@keyframes pb-1 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50%      { transform: translate(50px, -40px) rotate(30deg); }
}
@keyframes pb-2 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50%      { transform: translate(-40px, 50px) rotate(-25deg); }
}

.path-container {
  position: relative;
  z-index: 1;
  max-width: 960px;
  margin: 0 auto;
}

.path-header {
  text-align: center;
  margin-bottom: 20px;
}

.path-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 14px;
  background: rgba(3, 160, 84, 0.08);
  color: $leaf;
  border-radius: $r-pill;
  font-size: 0.72rem;
  font-weight: 700;
  margin-bottom: 14px;

  svg { width: 13px; height: 13px; }
}
.path-title {
  font-size: 1.5rem;
  font-weight: 800;
  color: $ink;
  margin: 0 0 6px;
  letter-spacing: -0.01em;
}

.path-subtitle {
  font-size: 0.88rem;
  color: $ink-soft;
  margin: 0;
  font-weight: 400;
}

.fork-divider {
  display: flex;
  justify-content: center;
  margin-bottom: 5px;
  color: rgba(3, 160, 84, 0.2);
}

.fork-svg {
  width: 100px;
  height: 36px;
}

.paths-grid {
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
}

.path-or {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 280px;
}

.or-line {
  flex: 1;
  height: 6px;
  background: linear-gradient(90deg, transparent, $line, transparent);
}

.or-badge {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #fff;
  border: 1.5px solid $line;
  font-size: 0.85rem;
  font-weight: 800;
  color: $ink-soft;
  box-shadow: $shadow-sm;
}

.path-card {
  width: 100%;
  max-width: 480px;
  background: #fff;
  border-radius: $r-lg;
  overflow: hidden;
  box-shadow: $shadow-warm-sm;
  transition: box-shadow 0.4s ease, transform 0.4s ease;

  &:hover {
    box-shadow: $shadow-warm-md;
    transform: translateY(-3px);
  }
}

.path-card-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px 22px 16px;
}

.path-card-icon {
  flex-shrink: 0;
  width: 46px;
  height: 46px;

  svg { width: 100%; height: 100%; }
}

.path-card-title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 800;
}

.path-card-sub {
  margin: 2px 0 0;
  font-size: 0.78rem;
  color: $ink-soft;
}

.path-direct {
  border: 1px solid rgba(200, 134, 26, 0.2);

  .path-card-header {
    background: linear-gradient(135deg, rgba(200, 134, 26, 0.06), rgba(232, 168, 56, 0.03));
  }

  .path-card-icon svg {
    color: $copper;
  }

  .path-card-title { color: $copper; }

  .path-card-sub { color: rgba(200, 134, 26, 0.7); }
}

.path-sarvban {
  border: 1px solid rgba(3, 160, 84, 0.2);

  .path-card-header {
    background: linear-gradient(135deg, rgba(3, 160, 84, 0.06), rgba(108, 177, 122, 0.03));
  }

  .path-card-icon svg {
    color: $leaf;
  }

  .path-card-title { color: $olive-dark; }

  .path-card-sub { color: rgba(3, 160, 84, 0.7); }
}

.path-steps {
  padding: 0 22px 8px;
}

.ps {
  display: flex;
  gap: 14px;
  align-items: flex-start;
}

.ps-num {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: $r-sm;
  font-size: 0.82rem;
  font-weight: 800;
  color: #fff;
  margin-top: 2px;

  &.ps-num-a {
    background: linear-gradient(135deg, $copper, $copper-soft);
    box-shadow: 0 3px 10px rgba(200, 134, 26, 0.3);
  }

  &.ps-num-b {
    background: linear-gradient(135deg, $olive, $olive-dark);
    box-shadow: 0 3px 10px rgba(3, 160, 84, 0.3);
  }
}

.ps-body {
  flex: 1;
  min-width: 0;
}

.ps-title {
  margin: 0 0 3px;
  font-size: 0.9rem;
  font-weight: 700;
  color: $ink;
}

.ps-desc {
  margin: 0;
  font-size: 0.78rem;
  line-height: 1.6;
  color: $ink-soft;
}

.ps-conn {
  display: flex;
  justify-content: center;
  padding: 2px 0;
  color: rgba(0, 0, 0, 0.12);

  svg { width: 16px; height: 26px; }
}

.path-services {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 4px 22px 16px;
}

.service-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  background: $copper-dim;
  border-radius: $r-pill;
  font-size: 0.7rem;
  font-weight: 600;
  color: $copper;

  svg { width: 12px; height: 12px; }
}

.path-benefits {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 4px 22px 16px;
}

.benefit {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  background: rgba(3, 160, 84, 0.06);
  border-radius: $r-pill;
  font-size: 0.7rem;
  font-weight: 600;
  color: $olive-dark;

  svg {
    width: 13px;
    height: 13px;
    stroke-width: 2.5;
  }
}

.path-cta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 13px 20px;
  border: none;
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 0 0 $r-lg $r-lg;

  svg { flex-shrink: 0; }

  &:active { transform: scale(0.98); }
}

.path-cta-direct {
  background: linear-gradient(135deg, $copper, $copper-soft);
  color: #fff;

  &:hover {
    background: linear-gradient(135deg, color.adjust($copper, $lightness: -6%), color.adjust($copper-soft,  $lightness: -4%));
   
  }
}

.path-cta-sarvban {
  background: linear-gradient(135deg, $olive, $olive-dark);
  color: #fff;

  &:hover {
    background: linear-gradient(135deg, $leaf-deep, color.adjust($leaf-soft, $lightness: -4%));
  }
}

.reveal {
  opacity: 0;
  transform: translateY(28px);
  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);
  transition-delay: var(--reveal-delay, 0ms);

  &.is-visible {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (min-width: 680px) {

.fork-divider {
  margin-bottom: -10px;
}
  .paths-grid {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    gap: 0;
    position: relative;
  }

  .path-or {
    position: absolute;
    top: 120px;
    left: 47%;
    transform: translateX(-50%);
    width: auto;
    flex-direction: column;
    gap: 0;
    z-index: 2;

    .or-line {
      width: 6px;
      height: 60px;
      background: linear-gradient(180deg, transparent, $line, transparent);
      flex: none;
    }

    .or-badge {
      width: 48px;
      height: 48px;
      font-size: 0.9rem;
    }
  }

  .path-card {
    max-width: 400px;
    margin: 0 8px;
  }

  .path-direct {
    margin-left: 40px;
  }

  .path-sarvban {
    margin-right: 40px;
  }
}

@media (min-width: 860px) {
  .path-card {
    max-width: 440px;
    margin: 0 12px;
  }

  .path-direct {
    margin-left: 60px;
  }

  .path-sarvban {
    margin-right: 60px;
  }

  .path-title {
    font-size: 1.8rem;
  }
}

@media (min-width: 1024px) {
  .path-card {
    max-width: 380px;
  }

  .path-direct {
    margin-left: 80px;
  }

  .path-sarvban {
    margin-right: 80px;
  }
}
</style>
